import { theme } from "../components/theme";

export const getColour = (name: string): string => {
  const colours: string[] = Object.keys(theme.avatarColors);
  const nameArr = name.split(" ");
  let charCodeTotal = 0;

  nameArr.forEach(part => {
    charCodeTotal += part.charAt(0).charCodeAt(0);
  });
  const colourName = (colours[ charCodeTotal % colours.length ]);
  const rgbValue = (theme.avatarColors as {[key: string]: string})[ `${colourName}` ];

  return rgbValue;
};